<ng-container *ngFor="let w of widgets" axf-widget-renderer [widget]="w" [parent]="this"  [mode]="'print'" [rIndex]="rIndex">
</ng-container>